<template>
  <div class="h-100">
    <div class="match-card match-card__more-matches text-center">

      <div class="match-card__desc">
        <div class="title">
          {{ trans.get('pages:match_game.no_more_card.question') }} <span>?</span>
        </div>
      </div>

      <div class="match-card__image">
        <img src="../../../images/match-game/filter.png" alt="Scaner icon">
      </div>
      <div class="match-card__desc">
        <div class="desc ">
          {{ trans.get('pages:match_game.no_more_card.slogan') }}
        </div>
      </div>
      <div class="match-card__button">
        <router-link :to="{name: 'members', hash: '#search'}" class="button button--primary">
          {{ trans.get('pages:match_game.no_more_card.show_settings_button') }}
        </router-link>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'NoMoreCard',
  props: {
    current: Object,
  },
  data() {
    return {};
  },
  computed: {
    avatars: function () {
      return this.$store.getters['homeProfiles/getRandomAvatars'];
    },
    ...mapGetters('user', {
      user: 'getUser',
    }),
  },
  methods: {},
  mounted() {
  }
};
</script>


